import React from 'react'
import { Button } from 'primereact/button'
import { Badge } from 'primereact/badge'
import { fileDownload } from 'api/FileDownload/fileDownload'

export const ContactLandingHeader = ({ 
    id,
    first, 
    rows, 
    totalCount,
    csvDownloadPath,
    csvDownloadName,
    excelDownloadPath,
    excelDownloadName,
    onRefresh,
    onAddContact
}) => {
    return (
        <div>
            <div className="row d-flex justify-content-flexend">
                <div className="col-auto">
                    <Button                         
                        id={id + '_container_add_contact'}
                        label="Add Contact"
                        icon="fa-light fa-plus"
                        onClick={onAddContact}
                        disabled={true}
                    />
                </div>
                <div className="col-auto mt-2">
                    <Badge value={`Displaying ${first + 1}-${Math.min(first + rows, totalCount)}`} />
                    <span className="mr-2" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}>
                        {' '}<b>of</b>{' '}
                    </span>
                    <Badge value={totalCount} />
                    <span className="mr-2" style={{ fontSize: "14px", fontWeight: "500", color: "black" }}>
                        {' '}<b>Contacts</b>{' '}
                    </span>
                </div>  
                <div className="col">
                    <Button
                        id={id + '_container_refresh'}
                        className="me-3"
                        label="Refresh"
                        icon="fa-light fa-refresh"
                        onClick={onRefresh}
                    />
                </div>
                <div className="col-auto">
                    <Button
                        id={id + '_container_export_csv'}
                        className="mr-3 ml-2"
                        icon="fa-light fa-file-import"
                        label="CSV Export"
                        onClick={() => fileDownload(csvDownloadPath, csvDownloadName)}
                        disabled={false}
                    />
                    <Button
                        id={id + '_container_export_excel'}
                        label="Excel Export"
                        icon="fa-light fa-file-import"
                        onClick={() => fileDownload(excelDownloadPath, excelDownloadName)}
                        disabled={false}
                    />
                </div>
            </div>
        </div>
    )
}
